export type NewPasswordFormUi = {
  isPasswordSubmitted?: boolean;
  password: string;
  showPassword?: boolean;
  passwordError?: string;
  confirmedPassword: string;
  showConfirmPassword?: boolean;
  confirmedPasswordError?: string;
  isButtonDisabled: boolean;
};

export const initialNewPasswordFormUi: NewPasswordFormUi = {
  password: '',
  confirmedPassword: '',
  isButtonDisabled: true,
};
